import { Alert, Button, Checkbox, Form, Input, InputNumber, Select } from 'antd'
import { useForm } from 'antd/lib/form/Form'
import * as React from 'react'
import { useEffect, useState } from 'react'
import { useHistory } from 'react-router'
import { PublisherBean } from 'src/api/api'
import { formDataLoader, FormDataType } from 'src/util/FormDataLoader'
import sovTemplateApi from './SOVTemplateApi'

const FormItem = Form.Item
const Option = Select.Option

interface Props {

}

const formInfoItems: FormDataType[] = [
    FormDataType.Publishers
]

const SOVTemplateCreate: React.FC<Props> = () => {

    const [form] = useForm()
    const [error, setError] = useState()
    const history = useHistory()

    const [info, setInfo] = useState({
        publishers: []
    })

    const handleSubmit = () => {
        form.validateFields().then(values => {
            sovTemplateApi
                .create({ ...values })
                .then(history.goBack)
                .catch(err => {
                    setError(err.error);
                })
        });
    };

    const loadFormData = async () => {
        try {
            let formInfo = await formDataLoader(...formInfoItems)
            setInfo(formInfo as any)
        } catch (e) {
            setError(e.error)
        }
    }

    useEffect(() => {
        loadFormData()
    }, [])

    return (
        <Form
            style={{
                maxWidth: '1000px'
            }}
            onFinish={handleSubmit}
            form={form}
            labelCol={{ span: 5 }}
            wrapperCol={{ span: 19 }}
        >
            {error ? <Alert message={error} type="error" /> : null}
            <FormItem
                name="publisherId"
                label="Publisher"
                tooltip="Available Publisher"
                rules={[
                    {
                        required: true,
                        message: 'Please select Publisher'
                    }
                ]}
            >
                <Select
                    optionFilterProp="title"
                    showSearch
                    allowClear
                    placeholder="Select Publisher"
                >
                    {info.publishers.map((item: PublisherBean) =>
                        <Option title={item.name} key={item.id} value={item.id as number}>{item.name}</Option>)}
                </Select>
            </FormItem>
            <FormItem
                name="name"
                rules={[
                    {
                        required: true,
                        message: 'Please input Deal Name'
                    },
                    {
                        max: 255,
                        message: 'Name cannot be longer that 255 characters'
                    }
                ]}
                label="Name"
                tooltip="Name"
            >
                <Input />
            </FormItem>
            <FormItem
                name="active"
                label="Active"
                valuePropName="checked"
                initialValue={true}
                tooltip={'If true it will be used for House Bidding'}
            >
                <Checkbox />
            </FormItem>
            <FormItem
                name="urlPattern"
                rules={[
                    {
                        required: true,
                        message: 'URL pattern required'
                    },
                    {
                        max: 255,
                        message: 'Name cannot be longer that 255 characters'
                    }
                ]}
                label="URL Pattern"
                tooltip="URL Pattern"
            >
                <Input />
            </FormItem>
            <FormItem
                name="adSizeList"
                rules={[
                    {
                        required: true,
                        message: 'Ad Size list of this template'
                    },
                    {
                        max: 255,
                        message: 'Name cannot be longer that 255 characters'
                    }
                ]}
                label="Ad Size list"
                tooltip="Ad Size list"
            >
                <Input />
            </FormItem>
            <FormItem
                name="maxTimeOfAds"
                rules={[
                    {
                        required: true,
                        message: 'Number of ads'
                    },
                    {
                        type: 'integer',
                        min: 1,
                        max: 10000,
                        message: 'Please input a valid number',
                    }
                ]}
                label="Max time of ads"
                tooltip="Max time of ads"
            >
                <InputNumber min={1} max={10000} />
            </FormItem>
            <FormItem
                name="numberOfAds"
                rules={[
                    {
                        required: true,
                        message: 'Number of ads'
                    },
                    {
                        type: 'integer',
                        min: 1,
                        max: 10000,
                        message: 'Please input a valid number',
                    }
                ]}
                label="Number of ads"
                tooltip="Number of ads"
            >
                <InputNumber min={1} max={10000} />
            </FormItem>
            <FormItem
                wrapperCol={{
                    offset: 11, span: 6
                }}>
                <Button style={{
                    width: '45%',
                    margin: '0 2%'
                }} type="primary" htmlType="submit">Create</Button>
                <Button style={{
                    width: '45%',
                    margin: '0 2%'
                }} type="primary" danger htmlType="button" onClick={history.goBack}>Cancel</Button>
            </FormItem>
        </Form>
    );
}

export default SOVTemplateCreate
